export const LISTABLE_TYPES = [
  'Folder',
  'Document',
  'Noticia',
  'News',
  'Locations',
  'Collections',
];
